import type { FC } from 'react'

import { Popup } from '@skytech/ui'

import { useTranslation } from '@/app/translations/translations-hooks'
import type { Asset } from '@/modules/admin/resources'
import { ComposeSMSModal } from '@/modules/admin/sms-sender/ComposeSMSModal'

import { useLeasedAssets } from '../AssetsLeased.context'

export const SendSMSPopup: FC<{
  assets: Asset[]
}> = ({ assets }) => {
  const translate = useTranslation()
  const { isActionPopupOpen, setIsActionPopupOpen } = useLeasedAssets()
  const numbers =
    assets.map(el => ({
      id: el.costObjectId,
      name: el.costObjectName,
      number: el.costObjectCode ?? '',
      countryId: el.costObjectCountryId,
    })) ?? []
  return (
    <Popup
      variant="wide"
      ariaLabel={translate('Send SMS')}
      isOpen={isActionPopupOpen}
      onClose={() => setIsActionPopupOpen(false)}
    >
      <ComposeSMSModal onClose={() => setIsActionPopupOpen(false)} numbers={numbers} />
    </Popup>
  )
}
